<div class="slide-notify ag-pa-md">
  @if (notifications && notifications?.alllMessageCount > 0) {
    <div>
      <h5 class="text=center">Your notifications</h5>
      @for (item of notifications?.allMessages; track item; let i = $index) {
        <mat-card
          appearance="outlined"
          class="example-card alert-info"
          [ngClass]="{
            'alert-info': !item?.unRead,
            'alert-warning': $safeNavigationMigration(item?.unRead)
          }"
          (click)="openNotification(item, i)"
        >
          <mat-card-header>
            <mat-card-title>{{ item?.msgTitle }}</mat-card-title>
          </mat-card-header>
          <mat-card-content class="slide-notify__mat-card-content">
            <div class="ellipsis" [innerHTML]="$safeNavigationMigration(item?.msgText)"></div>
            @if (item?.msgBegin) {
              <div>
                {{
                  isoFormatDMY(
                    parseISOString($safeNavigationMigration(item?.msgBegin)),
                    $safeNavigationMigration(item?.msgBegin)
                  )
                }}
              </div>
            }
            <hr />
            @if (item?.msgSignature) {
              <div>{{ item?.msgSignature }}</div>
            }
          </mat-card-content>
        </mat-card>
      }
    </div>
  }

  @if (!notifications || notifications?.alllMessageCount === 0) {
    <div>
      <h6>There are no notifications at this time</h6>
    </div>
  }
</div>
